import Sentinel from '@/common/Sentinel/Sentinel';

type OwnProps = {
  setIsSticky: (isSticky: boolean) => void;
};

export default function VehicleInfoSentinel({ setIsSticky }: OwnProps) {
  const handleIntersectionChange = (isIntersecting: boolean) => {
    setIsSticky(!isIntersecting);
  };

  return (
    <Sentinel
      onIntersectionChange={handleIntersectionChange}
      testId="vdp-sentinel"
    />
  );
}
